import { DatePipe, NgStyle, NgClass, NgIf, NgFor } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { APP_SETTINGS } from '@services';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { AdminService } from '../admin.service';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { SearchFilterPipe } from '../../../shared/pipes/search-filter.pipe';
import { SortByFilterPipe } from '../../../shared/pipes/sort-by-filter.pipe';
@Component({
    selector: 'app-show-bulletin-avg-report',
    templateUrl: './show-bulletin-avg-report.component.html',
    styleUrls: ['./show-bulletin-avg-report.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        FormsModule,
        NgStyle,
        NgClass,
        NgIf,
        NgFor,
        NgxPaginationModule,
        SearchFilterPipe,
        SortByFilterPipe,
    ],
})
export class ShowBulletinAvgReportComponent implements OnInit {

  search4users: string;
  errorMessage: string;
  makeName: string = 'BMW';
  public p;
  APP_SETTINGS:any;
  avgReportData: any[];
  priorDays: string;

  isDesc = false;
  column = '';
  direction: number;
  public searchRating;
  constructor(private spinnerService: SpinnerService, public date: DatePipe,
    private adminService: AdminService, private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.spinnerService.show("bmwSpinner");
    this.priorDays = "";
    this.errorMessage = "";
    this.adminService.getBulletinAvgRatingReport(this.makeName, this.priorDays).subscribe(reportData => {
      this.spinnerService.hide('bmwSpinner');
      this.avgReportData = reportData;
      this.cdr.markForCheck();
    }, error => {
      this.errorMessage = error.error.message;
      this.spinnerService.hide('bmwSpinner');
      this.cdr.markForCheck();
    });
  }

  downloadExcel() {
    this.spinnerService.show('bmwSpinner');
    this.adminService.downloadAvgStarReportExcel(this.makeName, this.priorDays).subscribe(data => {
      if (data) {
        const fileURL = URL.createObjectURL(data);
        this.spinnerService.hide('bmwSpinner');
        window.open(fileURL, '_blank');
      }
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.errorMessage = error.error.message;
      });
  }

  getAvgReportByMakeName(){
    this.adminService.getBulletinAvgRatingReport(this.makeName, this.priorDays).subscribe(reportData => {
      this.spinnerService.hide('bmwSpinner');
      this.avgReportData = reportData;
      this.cdr.markForCheck();
    }, error => {
      this.errorMessage = error.error.message;
      this.spinnerService.hide('bmwSpinner');
      this.cdr.markForCheck();
    });

  }
  getPriorDaysReport(){
    this.spinnerService.show("bmwSpinner");
    this.errorMessage = "";
    this.adminService.getBulletinAvgRatingReport(this.makeName,this.priorDays).subscribe(reportData => {
      this.spinnerService.hide('bmwSpinner');
      this.avgReportData = reportData;
      this.cdr.markForCheck();
    }, error => {
      this.avgReportData = [];
      this.errorMessage = error.error.message;
      this.spinnerService.hide('bmwSpinner');
      this.cdr.markForCheck();
    });
  }

  sortByProperty(propertyParam) {
    this.isDesc = !this.isDesc; // change the direction    
    this.column = propertyParam;
    this.direction = this.isDesc ? 1 : -1;
  }

  pageNumChange(event) {
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }

}
